import { jsx as c } from "react/jsx-runtime";
import { forwardRef as x, useState as y, useEffect as R } from "react";
import j from "@mui/material/Snackbar";
import v from "./components/SnackbarContent.js";
const z = {
  root: "snackbarRoot"
}, E = /* @__PURE__ */ x(({ action: s, classes: f, info: i, message: l, onClose: t, open: r, showClose: a = !0, showIcon: m = !0, title: u, variant: b = "info", anchorOrigin: k = {
  vertical: "bottom",
  horizontal: "center"
}, autoHideDuration: S = 3e3, resumeHideDuration: d = 1500, ...p }, h) => {
  const [w, o] = y(r);
  R(() => {
    o(r);
  }, [
    r
  ]);
  const e = (C, n) => {
    n !== "clickaway" && (o(!1), a && t && t(C, n));
  };
  return /* @__PURE__ */ c(j, {
    ...p,
    anchorOrigin: k,
    autoHideDuration: S,
    resumeHideDuration: d,
    ref: h,
    classes: {
      ...z,
      ...f
    },
    onClose: e,
    open: w,
    children: /* @__PURE__ */ c(v, {
      action: s,
      info: i,
      message: l,
      onClose: e,
      showClose: a,
      showIcon: m,
      title: u,
      variant: b
    })
  });
});
E.displayName = "Snackbar";
export {
  E as default
};
